import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useRoomSession } from '../../../../context/room_session';
import { AppText, Column, IconButtonWithLabel, Label, Sensor, Spinner, styled, Theme, Tooltip, } from '@streem/ui-react';
// matches with web/packages/ui-react/src/components/buttons/icon_button_with_label.styles.tsx
const MIN_WIDTH = '4.25rem';
export const ToolbarButton = ({ onClick, iconName, toolName, label, disableButton, disableTooltip, showErrorMsg, loading, fillLevel, tooltipMessage, tooltipStyles, roundLeftEdgeYn, roundRightEdgeYn, slashcolor, buttonStyles = {}, ...props }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [windowBlur, setWindowBlur] = useState(false);
    const roomSession = useRoomSession();
    // If the window loses focus while one of these buttons is in focus, it was showing the tooltip again on window re-focus.
    // So if the button is active when the window loses focus, don't show the tooltip again on refocus and reset that piece of state
    window.onblur = () => {
        if (document.activeElement?.textContent === label)
            setWindowBlur(true);
    };
    const show = () => {
        if (windowBlur) {
            setWindowBlur(false);
            return;
        }
        disableTooltip ? setShowTooltip(false) : setShowTooltip(true);
    };
    const hide = () => setShowTooltip(false);
    const handleClick = (e) => {
        toolName && roomSession.tools.setActiveTool(toolName);
        onClick?.(e);
    };
    const defaultMessage = (_jsx(AppText, { color: "dark", size: "small", children: label }));
    const handleClose = () => {
        setShowTooltip(false);
    };
    return (_jsx(Sensor, { onClickOutside: handleClose, onEscape: handleClose, children: _jsx(Tooltip, { message: tooltipMessage ? tooltipMessage : defaultMessage, showTooltip: showErrorMsg ? showErrorMsg : showTooltip, distance: tooltipStyles?.distance || 20, offsetValue: tooltipStyles?.offsetValue, borderRadius: tooltipStyles?.borderRadius, arrowSize: tooltipStyles?.arrowSize, children: !loading ? (_jsx(IconButtonWithLabel, { fillLevel: fillLevel, color: "blue50", hoverBackgroundColor: "grey10", hoverColor: "blue50", background: "transparent", backgroundColor: "white", highlight: "transparent", iconName: iconName, label: label, "data-testid": props['data-testid'], disabled: disableButton, onClick: handleClick, onMouseEnter: show, onMouseOver: show, onMouseOut: hide, onFocus: show, onBlur: hide, roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: roundRightEdgeYn, style: buttonStyles, slashcolor: slashcolor })) : (_jsxs(SpinnerWrapper, { onMouseEnter: show, onMouseOut: hide, onMouseOver: show, onFocus: show, onBlur: hide, children: [_jsx(Spinner, { size: "1.25rem" }), _jsx(Label, { "data-testid": `${iconName}-toolbar-button`, size: "small", color: "blue50", children: label })] })) }) }));
};
const SpinnerWrapper = styled(Column)(() => ({
    gap: '0.50rem',
    alignItems: 'center',
    paddingRight: Theme.spacing.m,
    paddingLeft: Theme.spacing.m,
    minWidth: MIN_WIDTH,
}));
//# sourceMappingURL=toolbar_button.js.map